$ = jQuery;

$(document).ready(function () {
    $('.section-age-boxes .age-pill').on('click', function () {
        var $card = $('#' + $(this).data('target'));
        if (!$card.length) {
            return;
        }
        $('.section-age-boxes .age-pill').removeClass('active');
        $(this).addClass('active');
        $('.section-age-boxes .age-card').attr('hidden', true);
        $card.removeAttr('hidden');
    });

    var initSlider = function ($el, query, options) {
        var mq = window.matchMedia(query);
        var slider = null;

        var toggle = function () {
            if (mq.matches && !slider) {
                slider = new Swiper($el[0], $.extend({
                    pagination: {
                        el: $el.find('.swiper-pagination')[0],
                        clickable: true
                    }
                }, options));
            } else if (!mq.matches && slider) {
                slider.destroy(true, true);
                slider = null;
                $el.find('.swiper-pagination').empty();
            }
        };

        toggle();
        mq.addEventListener('change', toggle);
    };

    var $competences = $('.section-competences .competences');
    if ($competences.length) {
        initSlider($competences, '(max-width: 767px)', {slidesPerView: 'auto', centeredSlides: true, spaceBetween: 10});
    }

    var $articles = $('.section-articles .articles');
    if ($articles.length) {
        initSlider($articles, '(max-width: 1080px)', {
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                600: {slidesPerView: 2}
            }
        });
    }

    var $reviews = $('.section-reviews .reviews');
    if ($reviews.length) {
        initSlider($reviews, $reviews.hasClass('has-slider') ? 'all' : '(max-width: 1080px)', {
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                600: {slidesPerView: 2},
                1081: {slidesPerView: 3, spaceBetween: 24}
            }
        });
    }

    // Newsletter success popup. The Mailchimp plugin submits over jQuery
    // ajaxForm and fires no JS event — success is only ever reported by an
    // .mc_success_msg landing in .mc_message_wrapper, so the popup watches
    // that wrapper. Append ?newsletter_success=1 to the URL to preview the
    // popup without submitting the form.
    var $popup = $('.newsletter-success-popup');
    if ($popup.length) {
        var popup = $popup[0];
        var lastFocused = null;
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        var openPopup = function () {
            if (!popup.hasAttribute('hidden')) {
                return;
            }
            lastFocused = document.activeElement;
            popup.removeAttribute('hidden');
            $('body').addClass('newsletter-popup-open');
            if (!reducedMotion.matches) {
                popup.classList.add('is-entering');
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        popup.classList.remove('is-entering');
                    });
                });
            }
            popup.querySelector('h2').focus();
        };

        var closePopup = function () {
            popup.setAttribute('hidden', '');
            $('body').removeClass('newsletter-popup-open');
            var target = lastFocused && document.contains(lastFocused) && lastFocused !== document.body
                ? lastFocused
                : $('.section-newsletter .mc_signup_form').find('input, select').get(0);
            if (target) {
                target.focus();
            }
            lastFocused = null;
        };

        $popup.find('.popup-close').on('click', closePopup);

        $popup.on('click', function (e) {
            if (!$(e.target).closest('.popup-content, .popup-close').length) {
                closePopup();
            }
        });

        $(document).on('keydown', function (e) {
            if (popup.hasAttribute('hidden')) {
                return;
            }
            if (e.key === 'Escape') {
                closePopup();
                return;
            }
            if (e.key !== 'Tab') {
                return;
            }
            var items = popup.querySelectorAll('a[href], button:not([disabled])');
            if (!items.length) {
                return;
            }
            var first = items[0];
            var last = items[items.length - 1];
            if (e.shiftKey && (document.activeElement === first || !$(document.activeElement).closest(popup).length)) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        });

        $('.section-newsletter .mc_message_wrapper').each(function () {
            var wrapper = this;
            new MutationObserver(function () {
                if (wrapper.querySelector('.mc_success_msg')) {
                    openPopup();
                }
            }).observe(wrapper, {childList: true, subtree: true});
        });

        if (new URLSearchParams(window.location.search).get('newsletter_success') === '1') {
            openPopup();
        }
    }

    var $featuredGames = $('.section-featured-games .featured-games');
    if ($featuredGames.length) {
        initSlider($featuredGames, $featuredGames.hasClass('has-slider') ? 'all' : '(max-width: 1080px)', {
            slidesPerView: 1.2,
            spaceBetween: 16,
            keyboard: {enabled: true, onlyInViewport: true},
            navigation: {
                prevEl: $('.section-featured-games .nav-prev')[0],
                nextEl: $('.section-featured-games .nav-next')[0]
            },
            breakpoints: {
                768: {slidesPerView: 2, spaceBetween: 24},
                1081: {slidesPerView: 3, spaceBetween: 24},
                1281: {slidesPerView: 4, spaceBetween: 32}
            }
        });
    }
});
